import axios from "axios";
import { getCookie } from "../../constants";
import Swal from "sweetalert2";
import { sweetAlertToast } from "../sweetAlert2";
import { deleteCookie } from "../func";

const HOTELS_LOGIN_URL = process.env.REACT_APP_TRP_HOTELS_URL

const cancelTokens = new Map();
// Test Api's
// export const AXIOS_CLIENT = axios.create({
//   baseURL: "https://testapi.xs2event.com/v1/",
//   headers: {
//     "x-api-key": "a0ba59fd6d00492089c0c5fc24a85a0e",
//     "Content-Type": "application/json",
//   },
// });

// On Live Server
// export const AXIOS_CLIENT = axios.create({
//   baseURL: "https://trpapi.technosoftwares.com/event/",
//   headers: {
//     "x-api-key": "U2FsdGVkX1+AIbdw8oU8pbfj4cW8SQxpszrK7m3xrKA=",
//     "Content-Type": "application/json",
//   },
// });

//Local Server
export const AXIOS_CLIENT = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "x-api-key": "U2FsdGVkX1+AIbdw8oU8pbfj4cW8SQxpszrK7m3xrKA=",
    "Content-Type": "application/json",
  },
});

AXIOS_CLIENT.interceptors.request.use(
  (config) => {
    let source = axios.CancelToken.source();
    if (cancelTokens.has(config.url)) {
      const prevSource = cancelTokens.get(config.url);
      prevSource.cancel("Request canceled because a new request was made.");
    }
    cancelTokens.set(config.url, source);
    config.cancelToken = source.token;
    const token = getCookie(process.env.REACT_APP_API_TOKEN);
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);


export const AXIOS_CLIENT_IMAGE = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "x-api-key": "U2FsdGVkX1+AIbdw8oU8pbfj4cW8SQxpszrK7m3xrKA=",
    "Content-Type": "image/svg+xml",
    "Accept": "image/svg+xml",
  }
})

AXIOS_CLIENT.interceptors.response.use(
  (response) => {
    if (
      !response.data.status &&
      response.data.message === "401 - Something Went Wrong ...!"
    ) {
      Swal.fire({
        title: "Error",
        text: "Your session has been expired. Please log in again.",
        icon: "error",
        confirmButtonText: "Okay",
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          deleteCookie(process.env.REACT_APP_API_TOKEN);
            window.location = HOTELS_LOGIN_URL;
        }
      });

    }
    return response;
  },
  (error) => {
    const config = error.config;
    if (!config) {
      console.error("Request configuration is undefined:", error);
      return Promise.reject(error);
    }
    if (axios.isCancel(error)) {
      console.log("Request canceled:", error.message);
    } else {
      console.error("API call failed:", error);
      const decryptedMessage = error.response.data.response
      if (error?.status === 403) {
        sweetAlertToast.fire({
          icon: "error",
          title: error.response.data.response.msg || decryptedMessage.msg || "Error 403"
        })
      }
    }
    cancelTokens.delete(config.url);
    if (error.response.status === 401) {
      sweetAlertToast.fire({
        icon: "error",
        title: error.response.config.url.toUpperCase() + ": UnAuthorized API Call..."
      })
      Swal.fire({
        title: "Error",
        text: "Your session has been expired. Please log in again.",
        icon: "error",
        confirmButtonText: "Okay",
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          deleteCookie(process.env.REACT_APP_API_TOKEN);
            window.location = HOTELS_LOGIN_URL;
        }
      });
    }
    if (error.response.status === 404) {
      sweetAlertToast.fire({
        icon: "error",
        title: error.response.config.url.toUpperCase() + ": API Not Found..."
      })
    }

    if (error.response.status === 500) {
      sweetAlertToast.fire({
        icon: "error",
        title: error.response.config.url.toUpperCase() + ": Something went wrong..."
      })
    }
    return error;
  }
);
